import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { LangToggle, Logo } from "@/components/landing/Nav";
import { useLang } from "@/lib/i18n";

export default function PageHeader({ wide = false }) {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <header className="border-b border-white/10">
      <div className={`mx-auto flex ${wide ? "max-w-6xl" : "max-w-3xl"} items-center justify-between px-4 py-5 sm:px-6`}>
        <Logo onClick={() => navigate("/")} />
        <div className="flex items-center gap-4">
          <LangToggle />
          <Link
            data-testid="page-back-link"
            to="/"
            className="flex items-center gap-2 text-sm font-semibold text-fog transition-colors hover:text-mint"
          >
            <ArrowLeft className="h-4 w-4" /> <span className="hidden sm:inline">{t("common.back")}</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
